const pluralize = (qty, singular, pluralized) =>
  qty === 1 ? singular : pluralized || `${singular}s`

export default pluralize
